import { useEffect } from 'react';

/**
 * Notifies the parent window of body height changes so an embedding iframe
 * can resize itself. Restrict the target origin in production by replacing
 * '*' with the Zoho Sites URL.
 */
export function useIframeResize() {
  useEffect(() => {
    if (window.parent === window) return; // not iframed

    const send = () => {
      const height = document.body.scrollHeight;
      window.parent.postMessage({ type: 'resize', height }, '*');
    };

    const ro = new ResizeObserver(send);
    ro.observe(document.body);
    send();

    return () => ro.disconnect();
  }, []);
}

/**
 * Tell the parent page to navigate (e.g., to the confirmation page where the
 * Meta Pixel fires the Schedule conversion event).
 */
/**
 * Avisa a la página que nos tiene embebidos que la cita quedó confirmada, para
 * que dispare ahí la conversión de Google Ads: en la página de arriba es donde
 * vive el gclid del anuncio. Si no estamos embebidos, se dispara acá mismo.
 */
export function avisarCitaConfirmada(datos: {
  servicio: string;
  servicioId?: string;
  codigo: string;
  reservaId: string;
  precio?: number;
  moneda?: string;
}) {
  if (window.parent === window) {
    const w = window as any;
    if (typeof w.gtag_report_conversion === 'function') {
      w.gtag_report_conversion(undefined, datos.codigo);
    }
    /* el mismo id que usa el worker al avisarle a Meta desde el servidor: así
       Meta entiende que es un solo evento y no dos */
    if (typeof w.fbq === 'function') {
      w.fbq('track', 'Schedule', {
        content_name: datos.servicio,
        value: datos.precio ?? 0,
        currency: datos.moneda ?? 'CRC',
      }, { eventID: datos.reservaId });
    }
    /* TikTok: la reserva confirmada, con el id de la reserva para que no la
       cuente dos veces si el evento llegara repetido */
    if (w.ttq && typeof w.ttq.track === 'function') {
      w.ttq.track('CompleteRegistration', {
        contents: [{
          content_id: datos.servicioId ?? datos.servicio,
          content_type: 'product',
          content_name: datos.servicio,
        }],
        value: datos.precio ?? 0,
        currency: datos.moneda ?? 'CRC',
      }, { event_id: datos.reservaId });
    }
    return;
  }
  window.parent.postMessage({ type: 'cita-confirmada', ...datos }, '*');
}

export function postParentRedirect(url: string) {
  if (window.parent === window) {
    window.location.href = url;
    return;
  }
  window.parent.postMessage({ type: 'redirect', url }, '*');
}
